import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {I18nService} from '../_services/gui/i18n.service';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule} from '@angular/forms';
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import {TabBarService} from '../_services/gui/tab-bar.service';
import {MatStep, MatStepper, MatStepLabel} from '@angular/material/stepper';
import {BusinessServicesOrderData, Profile} from '../_data/reports/business/request/business-services-order-data';
import {BusinessReportsService} from '../_services/data/reports/business-reports.service';
import {BusinessPicklistRow} from '../_data/reports/business/response/business-picklist-row';
import {AddOnRequest, Bizinquiry, OwnerAddress, OwnerCards, Owners} from '../_data/reports/business/request/bizinquiry';
import {stringify} from 'flatted';
import {ConfirmModalService} from '../_services/gui/confirm-modal.service';
import {BranchesService} from '../_services/data/branches.service';
import {MemberInfo} from '../_data/admin/member-info';
import {Router} from '@angular/router';
import {i18nKeyMap, isBlank, isNotBlank, nullIfBlank, reformatReferenceId, removeWhitespace, upperCase} from '../_utils/lang';
import {AuthenticationService} from '../_services/authentication.service';
import {CompaniesService} from '../_services/data/companies.service';
import {UsersService} from '../_services/data/users.service';
import {ReportsServicesBaseComponent} from '../common/reports-services-base.component';
import {NotificationService} from '../_services/gui/notification.service';
import {clearErrors, setOptional, valueExists} from '../_utils/forms';
import {Subject, Subscription} from 'rxjs';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {Phone} from '../_data/reports/phone';
import {BusinessRequest} from '../_data/reports/business/request/business-request';
import {ADDRESS_PATTERN, BUSINESS_REQUEST_CACHE_KEY, BUSINESS_RESPONSE_CACHE_KEY, POSTAL_PATTERN} from '../_constants/constants';
import {takeUntil} from 'rxjs/operators';
import {exists} from '../_utils/operators';
import {SidenavComponent} from '../sidenav/sidenav.component';
import {ServicesSideCardsComponent} from '../common/services-side-cards/services-side-cards.component';
import {NgClass, NgTemplateOutlet, AsyncPipe, UpperCasePipe, KeyValuePipe} from '@angular/common';
import {ValidationErrorsComponent} from '../common/forms/validation-errors/validation-errors.component';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap/tooltip';
import {RequiredComponent} from '../common/forms/required/required.component';
import {NgxMaskModule} from 'ngx-mask';
import {NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet} from '@ng-bootstrap/ng-bootstrap/nav';
import {AriaAttrsParentDirective} from '../_directives/aria-attrs-parent.directive';
import {OwnerProfileComponent} from './owner-profile/owner-profile.component';
import {BusinessSearchResultComponent} from './business-search-result/business-search-result.component';
import {OwnerConfirmComponent} from './owner-confirm/owner-confirm.component';
import {TranslateModule} from '@ngx-translate/core';

interface Product {
  code: string;
  desc: string;
}

// TODO: (bug) Step 1 icon breaks when on step 2

@Component({
    selector: 'app-business-services',
    templateUrl: './business-services.component.html',
    styleUrls: ['./business-services.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SidenavComponent, ServicesSideCardsComponent, MatStepper, MatStep, MatStepLabel, ReactiveFormsModule, NgClass,
       ValidationErrorsComponent, FaIconComponent, NgbTooltip, RequiredComponent, NgxMaskModule, NgTemplateOutlet, NgbNav, 
       NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, AriaAttrsParentDirective, NgbNavContent, OwnerProfileComponent,
        NgbNavOutlet, BusinessSearchResultComponent, OwnerConfirmComponent, AsyncPipe, UpperCasePipe, KeyValuePipe, TranslateModule]
})
export class BusinessServicesComponent extends ReportsServicesBaseComponent implements OnInit, OnDestroy {

  //////////////////////////
  // THIS CLASS IS A MESS //
  //////////////////////////

  public  readonly i18nService = inject(I18nService);

  faQuestionCircle = faQuestionCircle as IconProp;
  reformatReferenceId = reformatReferenceId;
  removeWhitespace = removeWhitespace;

  productTypes: Product[];
  addonProducts: Product[];
  profileArray: Profile[] = [];

  searchTypes: Map<string, string>;
  qualifiers: Map<string, string> = new Map(); // = ['Select One', 'Municipal', 'Provincial', 'Federal', 'Other'];
  cardTypes: Map<string, string> = new Map();
  provinceNames: Map<string, string>;
  editOwnerInfos: Map<string, string>;

  bizInquiry: Bizinquiry;
  productDescription: string;
  companyName: string;
  businessPicklistRows: BusinessPicklistRow[];
  tabs = [];
  counter = this.tabs.length + 1;
  active: any;

  serviceForm: UntypedFormGroup;
  serviceFormSubmitted = false;
  isNewOrder = false;
  ownerTabEnabled = false;
  businessTabError = false;
  ownerStaticTabError = false;
  ownerTabError: boolean[] = [false, false, false, false];

  @ViewChild('stepper') private readonly stepper: MatStepper;
  @ViewChild('step1') private readonly step1: MatStep;
  @ViewChild('step2') private readonly step2: MatStep;

  //TODO: refactor away from these.  Use the cancelSubscriptions$ variable below
  private bizProductsSubscription: Subscription;
  private selectedBranchSubscription: Subscription;
  private selectedProductSubscription: Subscription;
  private selectedBranchMemberCode: string;

  /** A Subject used to cancel any other subscriptions that are configured to use it. */
  private readonly cancelSubscriptions$: Subject<void> = new Subject<void>();


  private readonly router = inject(Router);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly tabBarService = inject(TabBarService);
  private readonly companiesService = inject(CompaniesService);
  private readonly businessesService = inject(BusinessReportsService);
  private readonly usersService = inject(UsersService);
  private readonly modalService = inject(ConfirmModalService)


  private static currentAddress(owner: any): OwnerAddress {

    return {
      street:       owner.street,
      streetnumber: owner.streetNum,
      apartment:    owner.apartmentNum,
      city:         owner.city,
      province:     owner.province,
      postal:       owner.postalCode,
      source:       null
    } as OwnerAddress;

  }

  private static previousAddress(owner: any): OwnerAddress {

    return {
      street:       owner.prevStreet,
      streetnumber: owner.prevStreetNum,
      apartment:    owner.prevApartmentNum,
      city:         owner.prevCity,
      province:     owner.prevProvince,
      postal:       owner.prevPostalCode,
      source:       null
    } as OwnerAddress;

  }

  private static newOwnerRequest(owner: Profile): Owners {
    const ownerAddressArray: OwnerAddress[] = [];
    if(owner.street !== '' && owner.city !== '' && owner.province !== '' && owner.postalCode !== '') {
      ownerAddressArray.push(BusinessServicesComponent.currentAddress(owner));
    }
    if(owner.prevStreet !== '' && owner.prevCity !== '' && owner.prevProvince !== '' && owner.prevPostalCode !== '') {
      ownerAddressArray.push(BusinessServicesComponent.previousAddress(owner));
    }
    return {
      ids:          [],
      addresses:    ownerAddressArray,
      phones:       [
        {
          phone:  owner.phone,
          source: null
        } as Phone
      ],
      lastname:     owner.lastName,
      firstname:    owner.firstName,
      middlename:   owner.middleName,
      dob:          owner.dob,
      sin:          owner.sin,
      pctOwnership: null,
      srcStreet:    null,
      srcPhone:     null,
      occupation:   owner.job,
      employer:     owner.employer,
      cards:        [
        {
          card:    owner.card,
          account: owner.account
        } as OwnerCards
      ],
      pairs:        [],
      tu4iSegments: null
    } as Owners;
  }

  private static isProfileValid(p: Profile): boolean {
    return (p && (p.dob !== '' || p.sin !== '' || p.card !== '' && p.account !== '') &&
      (p.street !== '' && p.city !== '' && p.province !== '' && p.postalCode !== '' && p.lastName !== '' && p.firstName)
    );
  }

  // Checks the value exists for identification - dob, sin and account
  private static isIdenticationValid(p: Profile): boolean {
    return (p && (isNotBlank(p.dob) || isNotBlank(p.sin) || (isNotBlank(p.card) && isNotBlank(p.account))));
  }

  // Checks the value exists for Name - first name, last name
  private static isNameValid(p: Profile): boolean {
    return (p && (isNotBlank(p.firstName) && isNotBlank(p.lastName)));
  }

  // Checks the value exists for Current Address
  private static isAddressValid(p: Profile): boolean {
    return (p && (isNotBlank(p.street) && isNotBlank(p.city) && isNotBlank(p.province) && isNotBlank(p.postalCode)));
  }

  // Checks the value exists for Previous Address
  private static isPrevAddressValid(p: Profile): boolean {
    return (p && (isNotBlank(p.prevStreet) && isNotBlank(p.prevCity) && isNotBlank(p.prevProvince) && isNotBlank(p.postalCode)));
  }

  // Checks the value not exists for identification - dob, sin and account
  private static isIdenticationBlank(p: Profile): boolean {
    return (p && (isBlank(p.dob) && isBlank(p.sin) && (isBlank(p.card) && isBlank(p.account))));
  }

  // Checks the value not exists for Name - first name, last name
  private static isNameBlank(p: Profile): boolean {
    return (p && (isBlank(p.firstName) && isBlank(p.lastName)));
  }

  // Checks the value not exists for Current Address
  private static isAddressBlank(p: Profile): boolean {
    return (p && (isBlank(p.street) && isBlank(p.city) && isBlank(p.province) && isBlank(p.postalCode)));
  }

  // Checks the value not exists for Previous Address
  private static isPrevAddressBlank(p: Profile): boolean {
    return (p && (isBlank(p.prevStreet) && isBlank(p.prevCity) && isBlank(p.prevProvince) && isBlank(p.postalCode)));
  }

  // With previous addresss
  private static withPrevAddress(p: Profile): boolean {
    if(BusinessServicesComponent.isNameValid(p) && BusinessServicesComponent.isIdenticationValid(p)
      && BusinessServicesComponent.isAddressValid(p) && BusinessServicesComponent.isPrevAddressValid(p)) {
      return false;
    } else if(BusinessServicesComponent.isNameBlank(p) && BusinessServicesComponent.isIdenticationBlank(p) && BusinessServicesComponent.isAddressBlank(p)) {
      return true;
    } else {
      return true;
    }
  }

  // Without previous address inclPrevAddress as '' or false
  private static withoutPrevAddress(p: Profile): boolean {
    if(BusinessServicesComponent.isNameValid(p) && BusinessServicesComponent.isIdenticationValid(p) && BusinessServicesComponent.isAddressValid(p)) {
      return false;
    } else if(BusinessServicesComponent.isNameBlank(p) && BusinessServicesComponent.isIdenticationBlank(p) && BusinessServicesComponent.isAddressBlank(p)) {
      return false;
    } else {
      return true;
    }
  }

  //Validates the owner profile values - returns true if error, returns false if no error
  private static isProfileError(p: Profile): boolean {
    if(p == null || Object.keys(p).length === 0) {
      return false;
    }
    let isOwnerError: boolean;
    if(p.inclPrevAddress === true) {
      // With previous addresss
      isOwnerError = BusinessServicesComponent.withPrevAddress(p);
      return isOwnerError;

    } else {
      // Without previous address inclPrevAddress as '' or false
      isOwnerError = BusinessServicesComponent.withoutPrevAddress(p);
      return isOwnerError;
    }
  }

  private addConfirmationSearchNum(required = false) {
    const control = required && new UntypedFormControl('', Validators.required) || new UntypedFormControl('');
    this.serviceForm.addControl('confirmationSearchNum', control);
    this.serviceForm.controls.confirmationSearchNum.updateValueAndValidity();
  }

  private getMemberCodeForBranch(branchName: string): string {
    if(branchName === null) {
      return '';
    }
    return this.branches.find(b => b.branchName === branchName).memberCode;
  }

  private businessValidators(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const businessOperatingName = group.get('businessOperatingName');
      const businessLegalName = group.get('businessLegalName');
      if(!valueExists(businessOperatingName) && !valueExists(businessLegalName)) {
        businessOperatingName.setErrors({oneOf: true});
        businessLegalName.setErrors({oneOf: true});
      } else if(valueExists(businessOperatingName) || valueExists(businessLegalName)) {
        clearErrors(businessOperatingName);
        clearErrors(businessLegalName);
      }
      return null;
    };
  }

  private loadQualifierTranslations() {
    //TODO: use getTranslationMap.  Could probably make this cleaner
    this.i18nService.getTranslations(
      'content.select-one', 'content.qualifiers.municipal', 'content.qualifiers.provincial', 'content.qualifiers.federal', 'content.other'
    ).subscribe(translations => {
      this.qualifiers.clear();
      this.qualifiers.set('', translations[0]);
      this.qualifiers.set('municipal', translations[1]);
      this.qualifiers.set('provincial', translations[2]);
      this.qualifiers.set('federal', translations[3]);
      this.qualifiers.set('other', translations[4]);
    });
  }

  private loadCardTypesTranslations() {
    //TODO: use getTranslationMap.  Could probably make this cleaner
    this.i18nService.getTranslations(
      'content.select-one', 'content.card.master', 'content.card.visa', 'content.card.cibc', 'content.card.hbc', 'content.card.samsclub', 'content.card.walmart',
      'content.card.linen', 'content.card.jcpenney', 'content.card.regency', 'content.card.bassett', 'content.card.petro', 'content.card.imperial', 'content.card.chase',
      'content.card.holt', 'content.card.laz'
    ).subscribe(translations => {
      this.cardTypes.clear();
      this.cardTypes.set('', translations[0]);
      this.cardTypes.set('master', translations[1]);
      this.cardTypes.set('visa', translations[2]);
      this.cardTypes.set('cibc', translations[3]);
      this.cardTypes.set('samsclub', translations[4]);
      this.cardTypes.set('walmart', translations[5]);
      this.cardTypes.set('linen', translations[6]);
      this.cardTypes.set('jcpenney', translations[7]);
      this.cardTypes.set('regency', translations[8]);
      this.cardTypes.set('bassett', translations[9]);
      this.cardTypes.set('petro', translations[10]);
      this.cardTypes.set('imperial', translations[11]);
      this.cardTypes.set('chase', translations[12]);
      this.cardTypes.set('holt', translations[13]);
      this.cardTypes.set('laz', translations[14]);
    });
  }

  // TODO: refactor this - way too messy.
  ngOnInit() {

    this.consumerBusinessIndicator = 'B';
    super.ngOnInit();

    
    this.i18nService.provinceNames
      .pipe(takeUntil(this.cancelSubscriptions$))
      .subscribe(value => this.provinceNames = value);

    this.i18nService.getTranslationMap({
      0: 'content.edit-owner-info.0',
      1: 'content.edit-owner-info.1',
      2: 'content.edit-owner-info.2',
      3: 'content.edit-owner-info.3'
    })
    .pipe(takeUntil(this.cancelSubscriptions$))
    .subscribe(value => this.editOwnerInfos = value);


    this.i18nService.setTitle('title.business-services');
    this.tabBarService.show();

    this.serviceForm = this.formBuilder.group(
      {
        serviceType:             ['', Validators.required],
        productType:             ['', Validators.required],
        referenceId:             ['', Validators.compose([Validators.required, Validators.maxLength(24)])],
        searchType:              ['', Validators.required],
        businessOperatingName:   '',
        businessLegalName:       '',
        businessRegistrationNum: '',
        qualifier:               '',
        streetName:              ['', Validators.compose([Validators.required, Validators.maxLength(48), Validators.pattern(ADDRESS_PATTERN)])],
        city:                    ['', Validators.compose([Validators.required, Validators.maxLength(33), Validators.pattern(ADDRESS_PATTERN)])],
        province:                ['', Validators.required],
        postalCode:              ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(POSTAL_PATTERN)])],
        businessTelephoneNumber: '',
        addonProducts:           this.formBuilder.group({}),
        profileStatic:           ''
      },
      {
        validators: this.businessValidators()
      }
    );

    this.loadQualifierTranslations();
    this.loadCardTypesTranslations();

    //Load translated searchTypes for dropdown
    this.i18nService.getTranslationMap(i18nKeyMap('content.keyed.prodtypes.', ['best', 'pick'])).subscribe(m => this.searchTypes = m);

    this.autoRef(this.serviceForm.controls.serviceType, () => this.branches, this.serviceForm.get('referenceId'));

    //Add a listener for serviceType (branch) changes and load the appropriate product types / addons
    this.selectedBranchSubscription?.unsubscribe();
    this.selectedBranchSubscription = this.serviceForm.controls.serviceType.valueChanges.subscribe((value: string) => {
      console.debug(`Selected branch changed.  Loading products for ${value}`);

      this.bizProductsSubscription?.unsubscribe();

      //If the user picked "select one" again, we need to clear the form
      if(isBlank(value)) {
        console.debug('Branch "Select one" picked');
        this.productTypes = [];
        this.serviceForm.controls.addonProducts = this.formBuilder.group({});
      } else {
        //Disable product dropdown until after it's loaded.
        this.serviceForm.controls.productType.disable();

        this.selectedBranchMemberCode = this.getMemberCodeForBranch(value);
        this.bizProductsSubscription = this.i18nService.repeatOnLangChange(() => this.branchesService.getMemberCodeInfo(this.selectedBranchMemberCode))
          .subscribe((memberInfo: MemberInfo) => {
            this.productTypes = memberInfo.si.productInfos
              .filter(item => item.productReportType === 'R')
              .map(item => ({code: item.product, desc: item.productName} as Product));

            const newAddonProducts: Product[] = memberInfo.si.productInfos
              .filter(item => item.productReportType === 'A' && item.allow === 'Y')
              .map(item => ({code: `a${item.product}`, desc: `${item.productName}`} as Product));

            const newAddonControls = {};
            newAddonProducts.forEach(item => {
              newAddonControls[item.code] = 'n';
            });

            this.serviceForm.controls.addonProducts = this.formBuilder.group(newAddonControls);
            this.addonProducts = newAddonProducts;

            this.serviceForm.controls.productType.enable();
          });
      }

    });

    //Set the validators for required fields
    //Toggle fields for different products
    this.selectedProductSubscription?.unsubscribe();
    this.selectedProductSubscription = this.serviceForm.controls.productType.valueChanges.pipe(exists()).subscribe((value: string) => {
      console.debug(`Product type changed to ${value}`);
      this.productTypes.forEach(product => {
        if(product.code === value) {
          this.productDescription = product.desc;
        }
      });
      const c = this.serviceForm.controls;
      this.serviceForm.removeControl('confirmationSearchNum');
      if(value === '05000' || value === '05002' || value === '05003' || value === '05004') {
        this.serviceForm.controls.searchType.setValue('');
        this.serviceForm.controls.searchType.enable({onlySelf: true});
        setOptional(
          c.businessOperatingName, c.businessLegalName, c.businessRegistrationNum, c.qualifier, c.businessTelephoneNumber);
        this.addConfirmationSearchNum();
      }
      this.cv4bBestMatch();
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.tabBarService.hide();
    this.bizProductsSubscription?.unsubscribe();

    //Trigger the configured subscriptions that are monitoring this one to cancel themselves.  Requires calling next and ALSO complete to work properly
    this.cancelSubscriptions$.next();
    this.cancelSubscriptions$.complete();
  }

  asIsOrder(a, b) {
    return -1;
  }

  cv4bBestMatch() {
    //To make one radio button disabled when other is enabled
    if(this.addonsGroup.controls.a00102?.value === 'y') {
      this.addonsGroup.controls.a00103?.disable();
    } else if(this.addonsGroup.controls.a00102?.value === 'n') {
      this.addonsGroup.controls.a00103?.enable();
    }
    if(this.addonsGroup.controls.a00103?.value === 'y') {
      this.addonsGroup.controls.a00102?.disable();
    } else if(this.addonsGroup.controls.a00103?.value === 'n') {
      this.addonsGroup.controls.a00102?.enable();
    }
    //To make the search only one option as Best Match for CV4B business only score and CV4B business & owners score
    if(this.addonsGroup.controls.a00102?.value === 'y' || this.addonsGroup.controls.a00103?.value === 'y') {
      this.serviceForm.controls.searchType.setValue('best');
      this.serviceForm.controls.searchType.disable({onlySelf: true});
    } else {
      this.serviceForm.controls.searchType.setValue('');
      this.serviceForm.controls.searchType.enable({onlySelf: true});
    }
    this.ownerTabEnabled = this.addonsGroup.controls.a00102?.value === 'y';
  }

  selectedAddon() {
    this.cv4bBestMatch();
  }

  unSelectedAddon() {
    this.cv4bBestMatch();
  }

  submitBusinessServiceForm(value) {
    console.log(this.serviceForm.value);
    console.debug(stringify(value));
    this.serviceFormSubmitted = true;
    if(this.serviceForm.valid) {
      console.debug(`SUCCESS!! :-) ${JSON.stringify(value)}`);
      if(this.ownerTabEnabled) {
        this.tabErrorInitialState();
        this.profileArray[0] = this.p2;
        this.profileArray[1] = this.p3;
        this.profileArray[2] = this.p4;
        this.profileArray[3] = this.p5;
      }
      this.step1.completed = true;
      this.stepper.next();
    } else {
      if(this.ownerTabEnabled) {
        this.checkTabLabel();
      }
    }
  }

  checkTabLabel() {
    // If Business and static owner tab having validation issues then Business tab will be selected for corrections
    this.checkDynamicTabLabels();
    this.checkStaticTabLabel();
    this.checkBusinessTabLabel();
  }

  // Checks the dynamic profile tabs that has validation issues will be highlighted in red and it will 
  // be automatically selected to allow for data input corrections.
  checkDynamicTabLabels() {
    for(let index = 3 ; index >= 0 ; index--) {
      if(this.serviceForm.get(`profile${index}`) !== null) {
        if(BusinessServicesComponent.isProfileError(this.serviceForm.get(`profile${index}`).value)) {
          this.ownerTabError[index] = true;
          this.active = index;
        } else {
          this.ownerTabError[index] = false;
        }
      }
    }
  }

  // Checks the Static profile tab that has validation issues will be highlighted in red and it will 
  // be automatically selected to allow for data input corrections.
  checkStaticTabLabel() {
    if(this.serviceForm.get(`profileStatic`) !== null) {
      if(BusinessServicesComponent.isProfileError(this.serviceForm.get(`profileStatic`).value)) {
        this.ownerStaticTabError = true;
        this.active = -1;
      } else {
        this.ownerStaticTabError = false;
      }
    }
  }

  // Checks the Business tab that has validation issues will be highlighted in red and it will 
  // be automatically selected to allow for data input corrections.
  checkBusinessTabLabel() {
    const bizName = this.serviceForm.get(`businessLegalName`).value;
    const operatingName = this.serviceForm.get(`businessOperatingName`).value;
    const street = this.serviceForm.get(`streetName`).value;
    const city = this.serviceForm.get(`city`).value;
    const postal = this.serviceForm.get(`postalCode`).value;
    const province = this.serviceForm.get(`province`).value;
    if((isBlank(bizName) && isBlank(operatingName)) || isBlank(street) || isBlank(city) || isBlank(postal) || isBlank(province)) {
      this.businessTabError = true;
      this.active = -2;
    } else {
      this.businessTabError = false;
    }
  }

  // To clear the error marking of Tab label
  tabErrorInitialState() {
    this.ownerTabError = [false, false, false, false];
    this.ownerStaticTabError = false;
    this.businessTabError = false;
    this.changeDetectorRef.markForCheck();
  }

  cancel() {
    this.tabErrorInitialState();
    this.serviceFormSubmitted = false;
    this.step1.completed = false;
    this.addonProducts = null;
    this.serviceForm.reset();
  }

  newOrder() {
    this.serviceFormSubmitted = false;
    this.step1.completed = false;
    this.addonProducts = null;
    this.businessPicklistRows = null;
    this.isNewOrder = false;
    this.stepper.previous();
    this.serviceForm.reset();
  }

  back() {
    this.stepper.previous();
    this.isNewOrder = false;
    this.businessPicklistRows = null;
  }

  submitReview(ariaLabelledBy: string, container: HTMLElement) {
    console.debug('Submit review');
    this.modalService.open(
      {i18nKey: 'content.confirm'},
      {i18nKey: 'content.request-report-disclaimer'},
      ariaLabelledBy,
      container
    ).result$.subscribe(accepted => {
      if(accepted) {
        console.debug(`OK clicked.  Searching pick list...`);
        this.searchForBusiness();
      }
    });
  }

  searchForBusiness() {
    const isSearchingPickList = this.v.searchType === 'pick';
    const addOnRequests: AddOnRequest[] = Object.entries(this.v.addonProducts)
      .filter(([, value]) => value === 'y')
      .map(([key]) => ({code: key.slice(1), delivery: 'Y'} as AddOnRequest));

    console.debug(stringify(addOnRequests));

    this.bizInquiry = {
      businesses: [
        {
          addresses:             [
            {
              street:   upperCase(this.v.streetName),
              city:     upperCase(this.v.city),
              province: upperCase(this.v.province),
              postal:   upperCase(this.v.postalCode),
              source:   nullIfBlank(upperCase(this.v.qualifier))
            }
          ],
          biznames:              [],
          businessIds:           [],
          businessLegalName:     upperCase(this.v.businessLegalName),
          businessName:          upperCase(this.v.businessOperatingName),
          businessRegInfoNum:    upperCase(removeWhitespace(this.v.businessRegistrationNum)),
          confirmationSearchNum: this.v.confirmationSearchNum,
          ids:                   [],
          pairs:                 [],
          phones:                [
            {
              phone:  this.v.businessTelephoneNumber,
              source: null
            }
          ]
        }
      ],
      meta:       {
        product:         this.v.productType,
        userId:          '',
        memberCode:      this.selectedBranchMemberCode,
        branchName:      this.v.serviceType,
        timestamp:       null,
        transactionId:   null,
        userReference:   this.reformatReferenceId(this.v.referenceId),
        language:        this.i18nService.currentLangShortCode,
        routing:         null,
        country:         null,
        addonProducts:   addOnRequests,
        errorCodes:      [],
        deliveryFormats: [],
        picklistOnly:    isSearchingPickList
      },
      owners:     []
    };

    if(this.ownerTabEnabled) {
      const ownerArray: Owners[] = [];
      if(BusinessServicesComponent.isProfileValid(this.p1)) {
        ownerArray.push(BusinessServicesComponent.newOwnerRequest(this.p1));
      }

      this.profileArray.forEach((element) => {
        if(BusinessServicesComponent.isProfileValid(element)) {
          ownerArray.push(BusinessServicesComponent.newOwnerRequest(element));
        }
      });

      this.bizInquiry.owners = ownerArray;
    }

    if(isSearchingPickList) {
      console.debug('Searching picklist');
      this.businessesService.searchPickList({bizinquiry: this.bizInquiry}).subscribe(data => {
        console.debug(`Got back ${stringify(data)}`);
        this.businessPicklistRows = data.picklist.rows;
        this.changeDetectorRef.markForCheck();
        return this.businessPicklistRows;
      });
      this.isNewOrder = true;
    } else {
      console.debug('Searching best match');
      this.businessesService.getBestMatch({bizinquiry: this.bizInquiry}).subscribe(data => {
        console.debug(`Got back`, data);
        const inqAndBusiness: BusinessRequest = {
          bizInquiry: this.bizInquiry, business: data.business, inquiryQualifier: this.v.qualifier, searchType: this.v.searchType, productDescription: this.productDescription
        };
        sessionStorage.setItem(BUSINESS_REQUEST_CACHE_KEY, JSON.stringify(inqAndBusiness));
        sessionStorage.setItem(BUSINESS_RESPONSE_CACHE_KEY, JSON.stringify(data));
        this.router.navigateByUrl('/business-services/credit-report');
      });
    }
  }

  submitBusinessServiceFormWithChild(value) {
    console.debug(stringify(value));
    this.serviceFormSubmitted = true;
    if(this.serviceForm.valid) {
      console.debug(`SUCCESS!! :-) ${JSON.stringify(value)}`);
      this.step1.completed = true;
      this.stepper.next();
    }
  }

  openBusinessTab() {
    this.stepper.previous();
    this.active = -2;
  }

  openFirstOwnerTab() {
    this.stepper.previous();
    this.active = -1;
  }

  openOwnerTab(tabId: number) {
    this.stepper.previous();
    this.active = tabId;
  }

  //Adding Owner Tab
  addOwnerTab() {
    //Add tab
    if(this.tabs.length < 4) {
      this.tabs.push(this.counter++);
      this.active = this.tabs.length - 1;
      const profileName = 'profile'.concat(this.active.toString());
      this.serviceForm.addControl(profileName, new UntypedFormControl());

      //Display notification
      this.notificationService.displayI18n('content.add-owner-message');
    }
  }

  //Confirm message for removal of Owner Tab
  confirmRemoveOwnerTab(toRemove: number, ariaLabelledBy: string, container: HTMLElement) {
    console.debug(' Confirm Remove Owner Tab');
    this.modalService.open(
      {i18nKey: 'content.confirm'},
      {i18nKey: 'content.remove-owner-confirm'},
      ariaLabelledBy,
      container
    ).result$.subscribe(accepted => {
      if(accepted) {
        this.removeOwnerTab(toRemove);
        console.log(`OK clicked.  Do you want to remove this owner?`);
      } else {
        console.log(`Cancel clicked.  Do you want not to remove this owner?`);
      }
    });

  }

  //Removes an owner tab from list of owner profile tabs
  removeOwnerTab(toRemove: number) {
    console.debug('Remove Owner Tab');

    //Remove tab
    this.profileArray[0] = this.p2;
    this.profileArray[1] = this.p3;
    this.profileArray[2] = this.p4;
    this.profileArray[3] = this.p5;

    //Removing the specified tab position from the owner tabs list
    this.profileArray.splice(toRemove, 1);

    //Set the values for all tabs after removing the specified tab position.
    //this.serviceForm.get(`profile${index}`).setValue(element) - is not required in case of ng-bootstrap.
    this.profileArray.forEach((element, index) => {
      this.serviceForm.setControl(`profile${index}`, new UntypedFormControl());
      this.serviceForm.get(`profile${index}`).setValue(element);
    });

    //Checks the next available tab values for removed tabs, if exists assigned with null value into that tab.
    //Suppose there are 5 tabs and removed 3rd tab then total available tabs are 4
    //and 5th tab will not be displayed in front end and also assigned with null value
    //The following logic is not required in case of ng-bootstrap.
    for(let index = this.profileArray.length ; index < 4 ; index++) {
      if(this.serviceForm.get(`profile${index}`) !== null) {
        this.serviceForm.get(`profile${index}`).setValue(null);
      }
    }

    console.log(`OK clicked.  Owner has been successfully removed.`);
    this.tabs.splice(toRemove, 1);
    this.active = toRemove - 1;

    //Display notification
    this.notificationService.displayI18n('content.remove-owner-message');

    //Tell Angular to check for changes so that it notices the tab was removed.
    this.changeDetectorRef.markForCheck();

  }

  get c(): {[p: string]: AbstractControl} {
    return this.serviceForm.controls;
  }

  get v(): BusinessServicesOrderData {
    return this.serviceForm.getRawValue();
  }

  get addonsGroup(): UntypedFormGroup {
    return this.serviceForm.controls.addonProducts as UntypedFormGroup;
  }

  get p1(): Profile {
    return this.serviceForm.getRawValue().profileStatic as Profile;
  }

  get p2(): Profile {
    return this.serviceForm.getRawValue().profile0 as Profile;
  }

  set p2(value: Profile) {
    this.serviceForm.controls.profile0.setValue(value);
  }

  get p3(): Profile {
    return this.serviceForm.getRawValue().profile1 as Profile;
  }

  set p3(value: Profile) {
    this.serviceForm.controls.profile1.setValue(value);
  }

  get p4(): Profile {
    return this.serviceForm.getRawValue().profile2 as Profile;
  }

  set p4(value: Profile) {
    this.serviceForm.controls.profile2.setValue(value);
  }

  get p5(): Profile {
    return this.serviceForm.getRawValue().profile3 as Profile;
  }

  set p5(value: Profile) {
    this.serviceForm.controls.profile3.setValue(value);
  }

}
